export default function reloadProfilePage() {
  if (window.location.pathname === '/profile') {
    window.location.reload();
    return;
  }

  window.location.assign('/profile');
}
